@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-number-input
      [formControl]="control"
      [invalidText]="createInvalidText(control)"
      [max]="attribute.max || undefined"
      [min]="attribute.min || undefined"
      [ngClass]="{'ix-invalid': control.errors}"
      [showStepperButtons]="true"
      class="w-100"
      [allowedCharactersPattern]="'[0-9,.-]'"
      [allowEmptyValueChange]="true"
      [pattern]="'^-?\\d*[.,]?\\d*$'"
      id="{{ attribute.name }}">
      @if (attribute.unit) {
        <ix-typography
          slot="end">{{ translateUnit('general.units', attribute.unit) }}
        </ix-typography>
      }
    </ix-number-input>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
